module.exports = __webpack_public_path__ + "media/images/nav_social/nav_whatsapp-3fce33fad43b3228200d84e952d3482d.svg";